<template>
  <div
    class="app-main-content"
    style="position:relative;"
  >
    <booking-tree-grid
      v-if="!openMultiple"
      v-show="view==='list'"
      ref="bookingTreeGrid"
      :context="context"
      :is-query="isQuery"
      :is-fba="isFba"
      @look="lookHandle"
      @edit="editHandle"
      @add="addHandle"
      @split="splitHandle"
      @copy="copyHandle"
    />
    <booking-workspace
      v-show="view==='detail'"
      ref="bookingWorkspace"
      :parent-context="context"
      :open-multiple="openMultiple"
      :is-fba="isFba"
      :view="view"
      @add="addHandle"
      @copy="copyHandle"
      @back="backToList"
      @refreshList="refreshList"
      @chargeLockStatusChange="chargeLockStatusChange"
    />
    <!--业务复制选择复制哪些信息-->
    <sea-booking-copy-window
      v-show="copyDialog.visible"
      ref="seaBookingCopyWindow"
      :visible.sync="copyDialog.visible"
      :lob="copyDialog.job.lob || ''"
      :is-master="copyDialog.job.masterFlag || false"
      @confirmCallBack="confirmCallBackHandler"
    />
    <job-no-rule-selector
      v-show="jobNoRule.visible"
      ref="jobNoRuleSelector"
      :visible.sync="jobNoRule.visible"
      :rules="jobNoRule.rules || []"
      @selectedBack="doCopyJob"
    />
  </div>
</template>

<script>
import { BookingNewContext } from './bookingNewContext'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import bookingTreeGrid from './components/booking/bookingTreeGrid'
import bookingWorkspace from './components/booking/bookingWorkspace'
import seaBookingCopyWindow from './components/booking/seaBookingCopyWindow'
import {
  applyExplicitCopyFieldsFromSource,
  createDefaultSeaBookingCopyOptions,
  parseGlobalCopyFieldConfig,
  prepareSeaBookingCopiedJobForDetail,
  SEA_BOOKING_COPY_CONFIG_MODULE,
  SEA_BOOKING_COPY_OPTIONS_CACHE_PREFIX,
  normalizeSchemeContent,
  resolveLegacyVesselEqSelected,
  isCopyFieldSelected
} from './components/booking/seaBookingCopyConfig'
import lodash from 'lodash'
import { ErrorTip } from '@/utils/class/ErrorTip'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  queryJobNoRule,
  doCopyJob,
  findSeaExportJobByNo,
  findSeaExportJobByUuid,
  advancedQuery
} from '@/api/seaExport/seaExportJob'
import { getGlobalQueryConfig } from '@/api/commonComponent'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { JumpUtil } from '@/utils/JumpUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'

export default {
  name: 'SeaBooking',
  components: { bookingTreeGrid, bookingWorkspace, seaBookingCopyWindow, jobNoRuleSelector },
  data() {
    return {
      context: BookingNewContext.getInstance(),
      openMultiple: Boolean(this.$route.query.openNew && this.$route.query.key && !this.$route.query.action), // （组件）打开了多个
      view: 'list',
      jumpActiveTabName: '',
      copyDialog: {
        visible: false,
        job: {},
        options: null,
        globalCopyFieldConfig: []
      },
      jobNoRule: {
        visible: false,
        rules: '',
        type: '',
        job: {}
      },
      isFba: false, // 是否FBA
      isQuery: false, // 根据路由参数进行高级查询
      loading: null
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    office() {
      return this.context.office || this.$store.getters.currentOffice
    }
  },
  watch: {
    officeId: {
      async handler(newVal) {
        if (this.office.officeId !== this.officeId) {
          await this.context.prepareData()
        }
      }
    }
  },
  async created() {
    await this.context.prepareData()
    if (this.$route.query.jobNo) {
      this.toDetail(this, this.$route.query.jobNo, this.$route.params.branchId, this.$route.query.activeTabName)
    }

    // 判断是否FBA
    const index = this.$route.path.lastIndexOf('/')
    const str = this.$route.path.substr(index + 1)
    this.isFba = str ? str.startsWith('FBA') : false
  },
  async mounted() {
    if (this.openMultiple) {
      this.view = 'detail'
      let rowData = this.$route.params.rowData
      console.log('rowData===========这是查询到的数据3', rowData)
      if (!rowData || rowData.length === 0) {
        const loading = getLoading4Cxt(this)
        try {
          const res = await findSeaExportJobByNo({ jobNo: this.$route.query.key, branchId: this.$store.getters.currentOfficeId })
          if (res.data.list.length === 0) {
            this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
            return
          }
          rowData = res.data.list
          console.log('rowData===========这是查询到的数据2', rowData)
        } catch (err) {
          this.$message.error(this.$t('Message.JumpFailed'))
          throw err
        } finally {
          loading.close()
        }
      }
      rowData = this.getNewDetailData(rowData)
      const selectedRow = rowData.find(p => p.jobNo === this.$route.query.key)
      if (selectedRow) {
        let action = 'look'
        if (this.$route.params.action) {
          action = this.$route.params.action
          delete this.$route.params.action
        }
        if (this.$route.params.activeTabName) {
          this.$refs.bookingWorkspace.activeTabName = this.$route.params.activeTabName
          delete this.$route.params.activeTabName
        }
        this.$refs.bookingWorkspace.onShow(action, rowData, selectedRow)
        console.log('selectedRow====', selectedRow)
      }
    } else if (this.$route.params.code) {
      this.isQuery = true
      this.view = 'list'
      this.sopNodeAdvancedQuery()
    }
  },
  async activated() {
    const params = this.$route.params
    if (params.conditions) {
      this.isQuery = true
      this.view = 'list'
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(params.conditions)
      delete params.conditions
    } else if (this.$route.params.jobNos) {
      await cache.load(cacheName.CONFIG)
      const filter = {
        combinedManifest: Number(cache.config.get('CombinedManifest')) === 1,
        fba: this.isFba
      }
      JumpUtil.jumpToTab(advancedQuery, filter, this.$route.params, this)
    } else if (this.$route.params.jobUuid) {
      const params = this.$route.params
      this.toDetailByUuid(params.jobUuid, params.activeTabName)
      delete params.jobUuid
      delete params.activeTabName
    } else if (this.$route.query.jobNo) {
      this.toDetail(this, this.$route.query.jobNo, this.$route.params.branchId, this.$route.query.activeTabName)
      location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
    } else if (this.$route.params.code) {
      if (this.$route.meta.showExtraParam) {
        this.view = 'list'
        this.$route.meta.showExtraParam = false
      }
      this.sopNodeAdvancedQuery()
    } else if (!this.openMultiple) {
      const saveJobNos = this.$route.params.saveJobNos
      const removedJobNos = this.$route.params.removedJobNos
      if (saveJobNos && removedJobNos) {
        delete this.$route.params.saveJobNos
        delete this.$route.params.removedJobNos
        if (this.view === 'list') {
          this.backToList(saveJobNos, removedJobNos)
        }
      }
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    // 首页sop面板高级查询
    sopNodeAdvancedQuery() {
      const { code, subCode, name, subName, newSubNodes, etdStart, templateKey } = this.$route.params
      let jobState = this.$route.params.jobState
      jobState = jobState.split(',').map(item => { return Number(item) })
      const data = [
        {
          fieldName: 'trackingInfo._multipleState_',
          fieldType: 'trackingMultiple',
          operator: '=',
          value: {
            operator: 'and',
            value: [
              {
                code,
                name,
                details: []
              }
            ]
          }
        },
        {
          fieldName: 'job.ETD',
          fieldType: 'FIELD_DATE_RANGE',
          operator: 'RANGE',
          value: `type=date,start=${etdStart}`
        },
        {
          fieldName: 'job.JOB_STATE',
          fieldType: null,
          label: '',
          operator: 'IN',
          value: jobState
        },
        { fieldType: 'FIELD_CHECKBOX', fieldName: 'loadRelationJobs', operator: '=', value: false }
      ]
      if (subCode && subName) {
        data[0].value.value[0]['details'].push({ code: subCode, name: subName })
      } else {
        data[0].value.value[0]['details'] = newSubNodes
      }
      // Sop模板UUID
      if (templateKey) {
        data.push(
          {
            fieldName: 'job.TRACKING_TEMPLATE_UUID',
            fieldType: null,
            label: '',
            operator: '=',
            value: templateKey
          }
        )
      }
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(data)
    },
    // 查询job后跳转详情
    toDetail(vm, jobNo, branchId, activeTabName) {
      const params = {}
      params.branchId = branchId || vm.$store.getters.currentOfficeId
      params.jobNo = jobNo
      params.pageNum = 1
      vm.view = 'detail'
      const loading = getLoading4Cxt(this)
      findSeaExportJobByNo(params).then(res => {
        const rowData = this.getNewDetailData(res.data.list)
        console.log('rowData===========这是查询到的数据', rowData)
        if (rowData.length !== 0) {
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          vm.$refs.bookingWorkspace.activeTabName = activeTabName || ''
          if (index > 0) {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          vm.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
          vm.$refs.bookingWorkspace.goBack()
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      }).finally(() => {
        loading.close()
      })
    },
    // 查询job后跳转详情（通过uuid）
    toDetailByUuid(jobUuid, activeTabName) {
      this.view = 'detail'
      const loading = getLoading4Cxt(this)
      findSeaExportJobByUuid({ jobUuid, branchId: this.$store.getters.currentOfficeId, pageNum: 1 }).then(res => {
        const rowData = this.getNewDetailData(res.data.list)
        console.log('rowData===========这是查询到的数据1', rowData)
        if (rowData.length !== 0) {
          const index = rowData.findIndex(p => p.jobUuid === jobUuid)
          this.$refs.bookingWorkspace.activeTabName = activeTabName || ''
          if (index > 0) {
            this.$refs.bookingWorkspace.onShow('look', rowData, rowData[index])
          } else {
            this.$refs.bookingWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
          this.$refs.bookingWorkspace.goBack()
        }
      }).catch(() => {
        this.$message.error(this.$t('Message.JumpFailed'))
      }).finally(() => {
        loading.close()
      })
    },
    toDetailByJob(job, activeTabName, jobs) {
      this.view = 'detail'
      this.$refs.bookingWorkspace.activeTabName = activeTabName || ''
      this.$refs.bookingWorkspace.onShow('look', jobs, job)
    },
    lookHandle(row) {
      if (this.jumpActiveTabName) {
        this.$refs.bookingWorkspace.activeTabName = this.jumpActiveTabName
        this.jumpActiveTabName = ''
      }
      this.detailHandle('look', row)
    },
    editHandle(row) {
      this.detailHandle('edit', row)
    },
    addHandle(row) {
      if (!this.office) {
        this.$message.info(this.$t('Message.CurrentBranchIsNotSelectedCannotAddNewBookings'))
        return
      }
      if (JobUtils.checkHQ()) { return }
      if (this.isFba) {
        row.fba = true
      }
      if (String(this.context.config.get('UseNewJobNoRule')) === '1') {
        this.jobNoRule.job = row
        this.confirmCallBackHandler('add')
        return
      }
      this.detailHandle('add', row)
    },
    splitHandle(row) {
      this.detailHandle('split', row)
    },
    backToList(saveJobNos, removedJobNos) {
      if (this.openMultiple) {
        if (this.isFba) {
          this.$router.push({ name: 'SeaBooking', params: { saveJobNos, removedJobNos }})
        }
        // 海运订舱 开启多业务，这里直接return
        return
      }
      if (this.$route.query.jobNo) {
        delete this.$route.query.jobNo
        delete this.$route.query.currentOfficeId
        delete this.$route.params.branchId
      }
      if (this.view === 'detail') {
        this.$refs.bookingTreeGrid.$el.style.display = 'none'
        this.$refs.bookingWorkspace.$el.style.display = 'inline-block'
      }
      const rowData = saveJobNos
      this.view = 'list'
      if (rowData && rowData.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.$refs.bookingTreeGrid.toQuery(rowData, removedJobNos)
      }
    },
    refreshList(jobNo) {
      setTimeout(() => {
        this.$refs.bookingTreeGrid.refreshQueryData(jobNo)
      })
    },
    async copyHandle(row) {
      if (!row) return
      if (JobUtils.checkHQ()) { return }
      this.copyDialog.job = row
      this.copyDialog.globalCopyFieldConfig = await this.getGlobalCopyFieldConfig()
      this.copyDialog.options = this.getCopyDialogOptions(row, this.copyDialog.globalCopyFieldConfig)
      this.copyDialog.visible = true
    },
    async getGlobalCopyFieldConfig() {
      if (this.copyDialog.globalCopyFieldConfig && this.copyDialog.globalCopyFieldConfig.length > 0) {
        return this.copyDialog.globalCopyFieldConfig
      }
      try {
        const res = await getGlobalQueryConfig(1, SEA_BOOKING_COPY_CONFIG_MODULE)
        this.copyDialog.globalCopyFieldConfig = parseGlobalCopyFieldConfig(res.data && res.data.configContent)
      } catch (err) {
        this.copyDialog.globalCopyFieldConfig = []
      }
      return this.copyDialog.globalCopyFieldConfig
    },
    getCopyCacheSuffix(job) {
      if (!job || !job.lob) {
        return ''
      }
      return job.masterFlag ? job.lob + '_MASTER' : job.lob
    },
    getCopyDialogOptions(job = this.copyDialog.job, globalCopyFieldConfig = this.copyDialog.globalCopyFieldConfig) {
      const cacheSuffix = this.getCopyCacheSuffix(job)
      if (!cacheSuffix) {
        return createDefaultSeaBookingCopyOptions(globalCopyFieldConfig)
      }
      const options = LocalStorageUtilsNew.getConfiguration(SEA_BOOKING_COPY_OPTIONS_CACHE_PREFIX + cacheSuffix) || {}
      return normalizeSchemeContent(options, globalCopyFieldConfig)
    },
    async confirmCallBackHandler(payload) {
      const type = typeof payload === 'string' ? payload : 'copy'
      if (payload && typeof payload === 'object' && payload.options) {
        this.copyDialog.options = payload.options
      } else if (!this.copyDialog.options) {
        this.copyDialog.options = this.getCopyDialogOptions(this.copyDialog.job, this.copyDialog.globalCopyFieldConfig)
      }
      if (String(this.context.config.get('UseNewJobNoRule')) === '1') {
        this.jobNoRule.type = type
        const loading = getLoading4Cxt(this)
        queryJobNoRule(SystemConstants.SE.code).then(res => {
          this.ruleResultHandler(res)
        }).finally(() => {
          loading.close()
        })
      } else {
        this.doCopyJob()
      }
    },
    ruleResultHandler(event) {
      const rules = event.data
      if (rules && rules.length > 1) {
        this.jobNoRule.visible = true
        this.jobNoRule.rules = rules
      } else if (rules && rules.length > 0) {
        const rule = rules[0]
        this.doCopyJob(rule)
      } else {
        this.$message.warning(this.$t('SeaExport.MaintainJobNoRule'))
        return
      }
    },
    doCopyJob(rule) {
      const jobNoRule = !rule ? '' : rule.uuid
      if (this.jobNoRule.type === 'add') {
        this.jobNoRule.job.jobNoRule = jobNoRule
        this.detailHandle('add', this.jobNoRule.job)
        return
      }
      const item = {}
      item.jobNoRule = jobNoRule
      item.jobUuid = this.copyDialog.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      const copyOptions = this.copyDialog.options || this.getCopyDialogOptions(this.copyDialog.job, this.copyDialog.globalCopyFieldConfig)
      const copyBooking = isCopyFieldSelected(copyOptions, 'booking')
      // 复制哪些页签的数据
      const lob = this.copyDialog.job.lob
      let notMatchAgainSelect = false
      if (this.copyDialog.job.masterFlag) {
        item.vesselEq = resolveLegacyVesselEqSelected(LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob + '_MASTER'), copyOptions)
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob + '_MASTER')
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob + '_MASTER')
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob + '_MASTER')
        item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob + '_MASTER')
        item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob + '_MASTER')
        notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob + '_MASTER')
      } else {
        item.vesselEq = resolveLegacyVesselEqSelected(LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob), copyOptions)
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob)
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob)
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
        item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob)
        item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob)
        notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob)
      }
      item.all = false
      item.masterFlag = this.copyDialog.job.masterFlag
      this.$logger.log('复制-item-条件', item)
      const loading = getLoading4Cxt(this)
      doCopyJob(item).then(async res => {
        let newJob = res.data
        newJob.copyNum = Number(item.copyNum) || 1
        if (!isCopyFieldSelected(copyOptions, 'op')) {
          newJob.opOffice = this.$store.getters.currentOfficeId || newJob.opOffice
        }
        newJob = applyExplicitCopyFieldsFromSource(this.copyDialog.job, newJob, copyOptions)
        // CARGO-28698 ID：5619 得翼 复制航线负责人保留
        // newJob.planner = 0
        if (!copyBooking) {
          newJob.soNo = ''
          newJob.bookingNo = ''
          newJob.returnPeriodBegin = ''
          newJob.returnPeriodEnd = ''
        }
        if (newJob.etd) {
          newJob.sailingDay = String(new Date(newJob.etd)).substr(0, 3).toUpperCase()
        }
        // newJob.fileCutoff = ''
        newJob.jobNoRule = item.jobNoRule
        const continueExec = await JobUtils.validateJobFieldActive(newJob, this, 'SeaBooking')
        if (!continueExec) {
          return
        }
        await JobUtils.doNotMatchAgainSelect(newJob, notMatchAgainSelect, { delay: !newJob.masterFlag })
        const isTp = String(cache.config.get('ToExoSystem')) === 'TP'
        if (isTp) {
          if (newJob.seaCargoDoc && newJob.seaCargoDoc.length > 0) {
            for (const cargoDoc of newJob.seaCargoDoc) {
              if (CargoDocConsts.MBL === cargoDoc.docType) {
                await JobUtils.handlerCargoDocLinebreaks(cargoDoc)
                break
              }
            }
          }
        }
        newJob = prepareSeaBookingCopiedJobForDetail(
          newJob,
          copyOptions
        )
        this.detailHandle('copy', newJob)
      }).finally(() => {
        loading.close()
      })
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.bookingWorkspace.rowData
      } else {
        rowData = []
        this.$refs.bookingTreeGrid.gridOptions.api.forEachNodeAfterFilterAndSort(node => {
          if (node.data) {
            rowData.push(node.data)
          }
        })
        rowData = this.getNewDetailData(rowData)
        this.view = 'detail'
      }
      if (row.uuid) {
        row = rowData.find(p => p.uuid === row.uuid)
      } else {
        new SeaExportJob(row).fillDefaultValue() // 数据补充完整
        row.version = 0 // 版本号置为0，重新加载job
        row = { ...row } // 需重新构造对象，以便新增加的属性可以被vue监听到
      }
      this.$refs.bookingWorkspace.saveJobNos = []
      this.$refs.bookingWorkspace.removedJobNos = []
      this.$refs.bookingWorkspace.onShow(type, rowData, row)
    },
    getNewDetailData(rowData) {
      rowData = lodash.cloneDeep(rowData)
      for (const item of rowData) {
        new SeaExportJob(item).fillDefaultValue() // 数据补充完整
        item.version = 0 // 版本号置为0，重新加载job
      }
      return rowData
    },
    //
    chargeLockStatusChange(lastJob) {
      if (this.openMultiple) {
        return
      }
      if (lastJob && this.$refs.bookingTreeGrid && this.$refs.bookingTreeGrid.rowData && this.$refs.bookingTreeGrid.rowData.length > 0) {
        for (const item of this.$refs.bookingTreeGrid.rowData) {
          if (item.uuid && item.uuid === lastJob.uuid) {
            item.receivableChargeLockedStatus = lastJob.receivableChargeLockedStatus
            item.payableChargeLockedStatus = lastJob.payableChargeLockedStatus
            break
          }
        }
        this.$refs.bookingTreeGrid.gridApi.refreshCells({ force: true }) // 刷新
      }
    }
  }
}
</script>

<style lang="scss">
</style>
